export function parseHubAttendanceQr(raw) {
  const text = String(raw || '').trim();
  if (!text) return '';
  if (/^DQHUB:/i.test(text)) {
    return text.split(':').slice(1).join(':').trim();
  }
  try {
    const parsed = JSON.parse(text);
    const type = String(parsed?.type || '').toUpperCase();
    const hubId = String(parsed?.hub_id || '').trim();
    if (type === 'HUB_ATTENDANCE' && hubId) return hubId;
  } catch {
    // not JSON
  }
  return '';
}
